















































































import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import BoxDetailsCard from '@/BoxDetailsCard.vue'
import CentralViewCard from '@/CentralViewCard.vue';
import { Project } from '../../../common/project';


@Component({
  components: {
    BoxDetailsCard
  }
})
export default class BoxCard extends mixins(CentralViewCard) {
  name = 'BoxCard';

  showDimensionsCard = false;

  closeDialog() {
    this.$store.commit('setBoxUnlockDialog', false);
  }

  get project() {
    return this.$store.state.currentProject
  }

  created() {
    this.name = 'BoxCard';
  }

  updated() {
    // console.log(`BoxCard update ${this.project ? this.project.name : "null"}`);
  }

  get boxDimensionNames() {
    return this.project.box.style != null ? this.project.box.style.dimensions : [];
  }

  get boxDimensionValues() {
    var mmValues = [];
    for ( var v of this.project.box.dimensions ) {
      mmValues.push(v*1000);
    }
    return mmValues;
  }

  get boardHeaders() {
    var boardHeaders = [];
    boardHeaders.push( { text:'Area [m²]', value: 'area', sortable: false, align: 'center'} )
    for (let i = 0; i < this.boxDimensionNames.length; i++) {
      let dim = this.boxDimensionNames[i];
      boardHeaders.push( { text: dim.name, value: i, sortable: false, align: 'center'} )
    }
    return boardHeaders;
  }

  get editable() {
    return !this.$store.getters.hasSimulationSuccess && !this.$store.getters.anyActiveSimulation;
  }

  get box() {
    return this.project && this.project.box;
  }

  get boardProp() {
    if (this.boxDimensionValues.length == 0)
      return [];

    var dimensions = {};
    const dimValues = this.boxDimensionValues;
    for (let i = 0; i < dimValues.length; i++) {
      dimensions[i] = dimValues[i];
    }
    var result = [ {
      area: this.box.areaSI,
      dimensions: dimensions
    }
    ]
    return result;
  }

  eraseSimulationResults() {
    this.project.eraseSimulationResults(this.$apollo);
  }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BoxCard.vue